import { clsx } from 'clsx'
import { Link } from '@/components/Link'
import { getLinkPathname } from '@/utils/urls'
import { Icon } from '../Icon'
import { Typography } from '../Typography'
import styles from './Title.module.scss'

export type TitleLink = {
  readonly noFollow?: boolean
  readonly url?: string
  readonly name?: string
  readonly target: string
  readonly type: 'section-link' | 'external-link'
}

export type TitleProps = {
  readonly children?: string
  readonly link?: TitleLink
  readonly big?: boolean
  readonly hasAdBadge?: boolean
  readonly noMargin?: boolean
  readonly topTitle?: boolean
  readonly className?: string
  readonly asH1?: boolean
}

const Title = ({ link, children, big, hasAdBadge, noMargin, topTitle, className, asH1 }: TitleProps) => {
  if (!children) {
    return <></>
  }

  const as = asH1 ? 'h1' : 'span'

  if (!link || !link.url) {
    return (
      <div
        className={clsx(styles.title, styles[`${className}`], {
          [styles['no-margin']]: noMargin,
          [styles['top-title']]: topTitle,
        })}
        title={children}
      >
        <Typography
          as={as}
          variant={big ? 'xxl' : 'l'}
          weight="bold"
          color="darkgrey"
          className={clsx({ [styles['top-title']]: topTitle })}
        >
          {children}
        </Typography>
        {hasAdBadge && (
          <Typography as="div" variant="xs" className={styles.ad}>
            Anzeige
          </Typography>
        )}
      </div>
    )
  }

  return (
    <Link
      className={clsx(styles.title, styles.link)}
      href={getLinkPathname(link.url)}
      target={link.target === '_blank' ? 'blank' : undefined}
      title={children}
    >
      <Typography as="span" variant={big ? 'xxl' : 'l'} weight="bold" color="darkgrey">
        {children}
      </Typography>
      <Icon className={styles.icon} name="chevronRight" size={24} />
      {hasAdBadge && (
        <Typography as="div" variant="xs" className={styles.ad}>
          Anzeige
        </Typography>
      )}
    </Link>
  )
}

export default Title
